class PasswordModal extends DetailsModal {
  constructor() {
    super();

    if (this.querySelector('input[aria-invalid="true"]')) this.open({ target: this.querySelector('details') });
  }
}

customElements.define('password-modal', PasswordModal);
document.addEventListener('DOMContentLoaded', function() {
  // Sélectionne le texte de la page mot de passe
  const passwordText = document.querySelector('.password__message');

  if(passwordText) {
    passwordText.style.display = 'none'; // Supprime le texte
  }

  // Centrer le logo et le formulaire
  const wrapper = document.querySelector('.password__container') || document.querySelector('.password__modal');
  if(wrapper) {
    wrapper.style.display = 'flex';
    wrapper.style.flexDirection = 'column';
    wrapper.style.alignItems = 'center';
    wrapper.style.justifyContent = 'center';
    wrapper.style.minHeight = '100vh';
    wrapper.style.textAlign = 'center';
  }
});
